import { render } from "./IconTooltip.vue?vue&type=template&id=4187cb7e"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__